export default "__VITE_ASSET__C8zlnRPA__"